module.exports = __webpack_public_path__ + "img/bgchome03.571f5849.jpg";